(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecs-form-submit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('copy-button')) {
    class CopyButton extends HTMLButtonElement {
      constructor() {
        super();
        this.addEventListener('click', this.copyToClipboard.bind(this));
      }

      copyToClipboard() {
        const url = this.dataset.url;
        const originalMsg = this.querySelector('.copy-msg');
        const successMsg = this.querySelector('.copy-success-msg');

        if (!url || !navigator.clipboard) return;

        navigator.clipboard
          .writeText(url)
          .then(() => {
            if (originalMsg && successMsg) {
              originalMsg.style.display = 'none';
              successMsg.style.display = 'inline';

              setTimeout(() => {
                originalMsg.style.display = 'inline-flex';
                successMsg.style.display = 'none';
              }, 2000);
            }
          })
          .catch((err) => {
            console.error('Failed to copy: ', err);
          });
      }
    }

    customElements.define('copy-button', CopyButton, { extends: 'button' });
  }

  } catch(e) { console.error(e); }
})();
})();
